var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.btnClass,attrs:{"href":_vm.to}},[_vm._t("default",function(){return [_vm._v("This is a btn")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }